import { IconType } from "react-icons";
import { FaHandshake, FaLeaf, FaTools } from "react-icons/fa";


interface FeatureType {
    icon: IconType;
    title: {
        ar: string;
        en: string;
    };
    content: {
        ar: string;
        en: string;
    };
}

export const features: FeatureType[] = [
    {
        icon: FaHandshake,
        title: {
            ar: "الالتزام",
            en: "Commitment",
        },
        content: {
            ar: "نلتزم بتنفيذ أعمال الاستيراد وفق الضوابط المعتمدة والجداول الزمنية المتفق عليها، مع الحرص على المصداقية والوضوح في جميع تعاملاتنا.",
            en: "We are committed to carrying out import operations in accordance with approved regulations and agreed timelines, with transparency and reliability in all dealings.",
        },
    },
    {
        icon: FaLeaf,
        title: {
            ar: "الجودة",
            en: "Quality",
        },
        content: {
            ar: "نحرص على استيراد الآلات والمستلزمات الزراعية من مصادر موثوقة لضمان الجودة والكفاءة وتوافق المنتجات مع المواصفات المعتمدة.",
            en: "We ensure the import of agricultural machinery and supplies from reliable sources to guarantee quality, efficiency, and compliance with approved standards.",
        },
    },
    {
        icon: FaTools,
        title: {
            ar: "الخبرة والاحترافية",
            en: "Expertise & Professionalism",
        },
        content: {
            ar: "نعتمد على خبرة عملية وفهم متطلبات القطاع الزراعي والحيواني، بما يضمن تقديم حلول عملية تخدم مختلف الأنشطة الزراعية بكفاءة.",
            en: "We rely on practical experience and a deep understanding of agricultural and livestock sector needs to deliver effective solutions with professionalism.",
        },
    },
];
